import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/mittagskarte",
    name: "Mittagskarte",
    component: () =>
      import(/* webpackChunkName: "mittagskarte" */ "../views/Mittagskarte.vue")
  },
  {
    path: "/speisekarte",
    name: "Speisekarte",
    component: () =>
      import(/* webpackChunkName: "speisekarte" */ "../views/Speisekarte.vue")
  },
  {
    path: "/ueberuns",
    name: "UeberUns",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  {
    path: "/galerie",
    name: "Galerie",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "galerie" */ "../views/Galerie.vue")
  },
  {
    path: "/kontakt",
    name: "Kontakt",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "kontakt" */ "../views/Kontakt.vue")
  },
  {
    path: "/impressum",
    name: "Impressum",
    component: () =>
      import(/* webpackChunkName: "impressum" */ "../views/Impressum.vue")
  },
  {
    path: "/datenschutz",
    name: "Datenschutz",
    component: () =>
      import(/* webpackChunkName: "datenschutz" */ "../views/Datenschutz.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  // eslint-disable-next-line
  scrollBehavior(to, from, savedPostion) {
    return { x: 0, y: 0 };
  }
});

export default router;
